module.exports = __webpack_public_path__ + "img/42.1d05053c.jpg";